import type { Category } from "./category";

import type { CommonRes, PublicLanguageCode } from ".";
import { api } from ".";

interface GetPartnersReq extends PublicLanguageCode {
  id: number;
  country: PublicLanguageCode["languageCode"];
}

interface Partner {
  id: number;
  image: string;
  title: string;
  description: string;
  link: string;
}

interface GetPartnerRes {
  total: number;
  list: Array<Partner>;
}

export const getPartners = ({ id, languageCode }: GetPartnersReq) =>
  api
    .get("partner", {
      searchParams: {
        partnerCategoryId: id,
        languageCode,
      },
    })
    .json<CommonRes<GetPartnerRes>>();

interface GetPartnerCategoriesRes {
  total: number;
  list: Array<Category>;
}

export const getPartnerCategories = ({ languageCode }: PublicLanguageCode) =>
  api
    .get("partner/category", {
      searchParams: {
        languageCode,
      },
    })
    .json<CommonRes<GetPartnerCategoriesRes>>();
